var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { TextField, TooltipHost, CommandBar, DetailsListLayoutMode, Pivot, PivotItem, ShimmeredDetailsList, Selection } from '@fluentui/react';
import { Subtitle } from './Subtitle';
import { Title } from './Title';
import { Column } from './Column';
import { isNull } from '../helpers/string-helper';
import { GenericDataTablePaginator } from './GenericDataTablePaginator';
import { Row } from './Row';
export class GenericDataTableComponent extends React.Component {
    constructor(props) {
        super(props);
        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    SelectedRows: this._selection.getSelection()
                }, () => {
                    if (this.props.onSelectedRow) {
                        this.props.onSelectedRow(this.state.SelectedRows);
                    }
                });
            }
        });
        this.state = {
            AllowDateFilter: props.allowDateSearch !== undefined ? this.props.allowDateSearch : false,
            allowSearch: props.allowSearch !== undefined ? props.allowSearch : true,
            columns: this._processColumns(props.columns),
            columnsAllowedToOrder: props.columnsAllowedToOrder || [],
            CommandBar: this._buildCommandBar(props.commandBarItems || []),
            commandBarFarItems: [],
            emptyImageUrl: props.emptyImageUrl || 'https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/images/empty-result.svg',
            ErrorLoading: false,
            ErrorLoadingMessage: '',
            externalCommandBarFarItems: props.commandBarFarItems,
            hideTools: props.hideTools !== void 0 ? props.hideTools : false,
            IsLoading: props.refreshOnInit === undefined || props.refreshOnInit === true,
            LastItem: 0,
            RecordsFiltered: 0,
            Request: { Filters: [], Length: props.itemsPerPage || 10, OrderColumn: props.initialOrderColumn || 0, Search: '', SortDirection: props.initialSortDirection || 'asc', Start: 1 },
            Rows: [],
            SelectedRows: [],
            SelectionMode: props.selectionMode,
            TotalPages: 0
        };
    }
    componentDidMount() {
        if (this.props.refreshOnInit === undefined || this.props.refreshOnInit === true) {
            if (typeof this.props.onRefreshDataTable === 'function') {
                this.props.onRefreshDataTable(this.state.Request);
            }
            else {
                this._refreshTable();
            }
        }
    }
    componentWillReceiveProps(props) {
        this.setState({
            allowSearch: props.allowSearch || true,
            CommandBar: this._buildCommandBar(props.commandBarItems || []),
            externalCommandBarFarItems: props.commandBarFarItems || [],
            hideTools: props.hideTools !== void 0 ? props.hideTools : false,
            emptyImageUrl: props.emptyImageUrl || 'https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/images/empty-result.svg',
            AllowDateFilter: props.allowDateSearch || false
        });
    }
    _buildCommandBar(items) {
        if (typeof this.props.hideRefreshButton === 'boolean' && this.props.hideRefreshButton) {
            return items;
        }
        else {
            return [
                ...items,
                {
                    key: 'refresh',
                    name: 'Actualizar',
                    iconProps: { iconName: 'Refresh' },
                    onClick: () => {
                        if (typeof this.props.onRefreshDataTable === 'function') {
                            this.props.onRefreshDataTable(this.state.Request);
                        }
                        else {
                            this._refreshTable();
                        }
                    }
                }
            ];
        }
    }
    render() {
        const searchClassName = this.state.allowSearch && this.state.AllowDateFilter ? 'ms-Grid-col ms-sm7 ms-md8 ms-lg7' : this.state.allowSearch ? 'ms-Grid-col ms-sm9 ms-md10 ms-lg9' : 'ms-Grid-col ms-sm12 ms-md12 ms-lg12';
        // Crear commandbar
        const commandBar = React.createElement(CommandBar, { items: this.state.CommandBar, className: 'command-bar-1', farItems: this.state.commandBarFarItems });
        // Cuadro de búsqueda
        const searchBox = React.createElement(TooltipHost, { content: this.props.searchTooltip ? this.props.searchTooltip : '', calloutProps: { gapSpace: 0 } },
            React.createElement(TextField, { placeholder: 'Buscar...', borderless: true, className: 'mp-search', style: { height: '44px', backgroundColor: 'rgba(244, 244, 244, 0.43)' }, onChange: (_, value) => {
                    this.setState({
                        Request: Object.assign(Object.assign({}, this.state.Request), { Search: value })
                    });
                }, iconProps: { iconName: 'Search' }, onKeyUp: (event) => {
                    if (!this.state.IsLoading) {
                        if (event.keyCode === 13) {
                            this.setState({
                                Request: Object.assign(Object.assign({}, this.state.Request), { Start: 1 })
                            }, () => {
                                if (this.props.customSearch) {
                                    this.props.customSearch(this.state.Request);
                                }
                                else {
                                    this._refreshTable();
                                }
                            });
                        }
                    }
                } }));
        const onRenderFooter = (dProps) => {
            const columns = dProps.columns;
            if (columns.length > 0 && columns[columns.length - 1].key === '-empty-') {
                columns.splice(columns.length - 1, 1);
            }
            return React.createElement("div", { role: "presentation" },
                React.createElement("div", { role: "presentation", className: "ms-FocusZone focusZone_f2db561a", "data-focuszone-id": "FocusZone173" },
                    React.createElement("div", { className: "ms-SelectionZone", role: "presentation" },
                        React.createElement("div", { role: "presentation", className: "ms-List" },
                            React.createElement("div", { className: "ms-List-surface", role: "presentation" },
                                React.createElement("div", { className: "ms-List-page", role: "presentation" },
                                    React.createElement("div", { role: "presentation", className: "ms-List-cell", "data-list-index": "0", "data-automationid": "ListCell" },
                                        React.createElement("div", { role: "row", className: "ms-FocusZone ms-DetailsRow css-230 root_ee38960f owner_8478e118", "data-is-focusable": "true", "data-selection-index": "0", "data-item-index": "0", "aria-aria-rowindex": "1", "data-is-draggable": "false", "data-automationid": "DetailsRow", "aria-selected": "false", "data-focuszone-id": "FocusZone177" },
                                            React.createElement("div", { role: "gridcell", "arial-colindex": "1", "data-selection-toggle": "true", className: "ms-DetailsRow-cell ms-DetailsRow-cellCheck owner_8478e118 cell_ee38960f checkCell_ee38960f" },
                                                React.createElement("div", { role: "checkbox", className: "ms-DetailsRow-check check_8478e118 checkHost_904a6025", "aria-checked": "false", "data-selection-toggle": "true", "data-automationid": "DetailsRowCheck" })),
                                            React.createElement("div", { className: "ms-DetailsRow-fields fields_ee38960f", "data-automationid": "DetailsRowFields", role: "presentation" }, dProps.columns.map(column => React.createElement("div", { role: "gridcell", "aria-aria-colindex": "2", className: "ms-DetailsRow-cell cell_ee38960f", "data-automationid": "DetailsRowCell", "data-automation-key": "DepartamentoDestino", style: { width: (column.currentWidth + 16) + 'px' } }, (typeof this.props.onRenderFooter === 'function' && this.props.onRenderFooter(column)) || ''))),
                                            React.createElement("span", { role: "checkbox", className: "checkCover_ee38960f", "aria-checked": "false", "data-selection-toggle": "true" })))))))));
        };
        // DetailList
        const list = React.createElement(ShimmeredDetailsList, { items: this.state.Rows, columns: this.state.columns, selectionMode: this.state.SelectionMode, layoutMode: DetailsListLayoutMode.justified, isHeaderVisible: true, onShouldVirtualize: () => false, enableShimmer: this.state.IsLoading, selectionPreservedOnEmptyClick: true, selection: this._selection, shimmerLines: this.state.Rows.length || this.state.Request.Length, className: this.props.hideHeaders === true ? 'detail-list-no-header' : '', onRenderDetailsFooter: this.props.showFooter ? onRenderFooter : void 0, listProps: {} });
        // Renderizar tools
        const tools = this.props.onRenderTools !== void 0 ? this.props.onRenderTools() : void 0;
        const paginator = React.createElement("div", { className: 'ms-Grid-row' },
            this.state.TotalPages > 0 && React.createElement("div", { className: 'ms-Grid-col ms-sm12 ms-md6 ms-lg6', style: { paddingTop: '12px' } }, !this.state.IsLoading && React.createElement("span", null,
                "Mostrando ",
                ((this.state.Request.Start - 1) * this.state.Request.Length) + 1,
                " al ",
                this.state.LastItem,
                " de ",
                this.state.RecordsFiltered)),
            this.state.TotalPages > 0 && React.createElement("div", { className: 'ms-Grid-col ms-sm12 ms-md6 ms-lg6', style: { textAlign: 'right' } },
                React.createElement(GenericDataTablePaginator, { currentPage: this.state.Request.Start, totalPages: this.state.TotalPages, onChange: (page) => {
                        this.setState({
                            Request: Object.assign(Object.assign({}, this.state.Request), { Start: page })
                        }, () => this._refreshTable());
                    } })));
        return React.createElement(React.Fragment, null,
            this.props.title && this.props.title.trim().length > 0
                && React.createElement(React.Fragment, null, this.props.principalForm
                    ? React.createElement(Title, { className: this.props.titleClassName, text: this.props.title ? this.props.title : '' })
                    : React.createElement(Subtitle, { className: this.props.subtitleClassName, text: this.props.title ? this.props.title : '' })),
            tools,
            !this.state.hideTools && React.createElement(Row, null,
                React.createElement("div", { className: searchClassName, style: this.props.bodyStyle || { padding: '0px', paddingLeft: '8px' } }, commandBar),
                this.state.allowSearch && React.createElement("div", { className: 'ms-Grid-col ms-sm3 ms-md2 ms-lg3', style: { padding: '0px' } }, searchBox)),
            React.createElement(Row, null,
                this.props.pivotItems !== void 0 && this.props.pivotItems.length > 0 &&
                    React.createElement(Column, { size: 12 },
                        React.createElement(Pivot, { onLinkClick: this._pivotItemClick.bind(this) }, this.props.pivotItems.map(o => React.createElement(PivotItem, { key: o, headerText: o }, (this.state.Rows.length > 0 || this.state.IsLoading) && React.createElement("div", { style: this.props.bodyStyle || {} }, list))))),
                (this.props.pivotItems === void 0 || this.props.pivotItems.length === 0) && React.createElement(Column, { size: 12 }, (this.state.Rows.length > 0 || this.state.IsLoading) && React.createElement("div", { style: this.props.bodyStyle || {} }, list))),
            !this.state.IsLoading && this.state.Rows.length === 0 && React.createElement(Row, null,
                React.createElement(Column, { size: 12 },
                    React.createElement("div", { style: { textAlign: 'center', userSelect: 'none' } },
                        (this.props.hideEmptyImage === undefined || this.props.hideEmptyImage === false) && React.createElement("div", null,
                            React.createElement("img", { style: {
                                    height: '128px',
                                    width: '128px'
                                }, src: this.state.emptyImageUrl, alt: "Sin Resultados" })),
                        React.createElement("div", null,
                            React.createElement("span", { style: { color: '#585858' } }, this.props.emptyMesssage || 'No hay datos para mostrar en este momento'))))),
            paginator);
    }
    _OnChangeInitialDate(newValue) {
        if (!this.state.IsLoading) {
            if (newValue != null) {
                if (this.state.Request.InitialDate === newValue) {
                    return;
                }
                else {
                    this.setState({
                        Request: Object.assign(Object.assign({}, this.state.Request), { InitialDate: newValue })
                    }, () => {
                        if (this.props.customSearch) {
                            this.props.customSearch(this.state.Request);
                        }
                        else {
                            this._refreshTable();
                        }
                    });
                }
            }
        }
    }
    ;
    _OnChangeEndDate(value) {
        if (!this.state.IsLoading) {
            if (value != null) {
                if (this.state.Request.EndDate === value) {
                    return;
                }
                else {
                    this.setState({
                        Request: Object.assign(Object.assign({}, this.state.Request), { EndDate: value })
                    }, () => {
                        if (this.props.customSearch) {
                            this.props.customSearch(this.state.Request);
                        }
                        else {
                            this._refreshTable();
                        }
                    });
                }
            }
        }
    }
    ;
    _processColumns(columns) {
        if (columns === void 0) {
            columns = [];
        }
        columns = columns.filter(o => o != null);
        const columnClick = (column) => {
            column.onColumnClick = () => {
                const allowed = this.state.columnsAllowedToOrder || [];
                if (allowed.length === 0 || allowed.includes(column.key)) {
                    const columns = this.state.columns.slice();
                    const index = columns.findIndex(o => o.key === column.key);
                    columns[index].isSortedDescending = !columns[index].isSortedDescending;
                    columns[index].isSorted = true;
                    columns.filter(o => o.key !== columns[index].key).forEach(o => o.isSorted = false);
                    this.setState({
                        Request: Object.assign(Object.assign({}, this.state.Request), { OrderColumn: this.state.columns.findIndex(o => o.key === column.key), SortDirection: column.isSortedDescending ? 'desc' : 'asc' }),
                        columns: columns
                    }, () => this._refreshTable());
                }
            };
        };
        for (let i = 0; i < columns.length; i++) {
            columnClick(columns[i]);
        }
        return columns;
    }
    clearSelection() {
        this._selection.setAllSelected(false);
    }
    _refreshTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.props.procesox === true && this.props.runtime === false) {
                this.setState({
                    IsLoading: false,
                    ErrorLoading: false,
                    ErrorLoadingMessage: ''
                });
                return;
            }
            this._selection.setAllSelected(false);
            this.setState({
                IsLoading: true
            });
            let request = yield this._processRequest();
            // Actualizar datos del DetailList
            let func = this.props.paginationMethodName && this.props.paginationMethodName !== '' ?
                this.props.service[this.props.paginationMethodName] :
                this.props.service.paginateAsync;
            if (func === undefined) {
                throw new Error('El servicio proporcionado no esta implementado en JS');
            }
            let args = [];
            if (this.props.paginationMethodArgs) {
                args = args.concat(this.props.paginationMethodArgs());
            }
            args.push(request);
            func.apply(this.props.service, args).then((result) => {
                // Verificar datos de la respuesta
                let lastItem = ((request.Start > 0 ? request.Start - 1 : request.Start) * request.Length) + request.Length;
                if (lastItem > result.RecordsFiltered) {
                    lastItem = result.RecordsFiltered;
                }
                else if (this.props.hideTools !== void 0) {
                    lastItem = result.RecordsFiltered;
                }
                // Actualizar datos
                this.setState({
                    IsLoading: false,
                    TotalPages: request.Length > 0 && this.props.hideTools === void 0 ? Math.ceil(result.RecordsFiltered / request.Length) : 0,
                    Rows: result.Data,
                    RecordsFiltered: result.RecordsFiltered,
                    LastItem: lastItem
                }, () => {
                    this.setState({
                        commandBarFarItems: this._buildCommandBarFarItems()
                    });
                    if (this.props.onAfterRefresh) {
                        this.props.onAfterRefresh(result);
                    }
                });
            }).catch(() => {
                this.setState({
                    IsLoading: false,
                    ErrorLoading: true,
                    ErrorLoadingMessage: 'Se ha producido un error al cargar los datos'
                });
            });
        });
    }
    reset() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({
                IsLoading: false,
                TotalPages: 0,
                Rows: [],
                RecordsFiltered: 0,
                LastItem: 0
            }, () => {
                this.setState({
                    commandBarFarItems: this._buildCommandBarFarItems()
                });
            });
        });
    }
    getDataTableRequest() {
        return this.state.Request;
    }
    get length() {
        var _a, _b;
        return ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.Rows) === null || _b === void 0 ? void 0 : _b.length) || 0;
    }
    _processRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            // Crear solicitud
            let request = Object.assign({}, this.state.Request);
            request.Filters = [];
            // Ejecutar evento OnBeforeSend
            if (this.props.onBeforeSend) {
                request = yield this.props.onBeforeSend(request);
            }
            if (!isNull(request.Filters)) {
                for (let i = 0; i < request.Filters.length; i++) {
                    const element = request.Filters[i];
                    if (!isNull(element.Value)) {
                        element.Value = String(element.Value);
                    }
                }
            }
            return request;
        });
    }
    _buildCommandBarFarItems() {
        const items = [];
        // Agregar elementos personalizados
        if (this.state.externalCommandBarFarItems != null && this.state.externalCommandBarFarItems.length > 0) {
            for (let i = 0; i < this.state.externalCommandBarFarItems.length; i++) {
                const farItem = this.state.externalCommandBarFarItems[i];
                items.push(farItem);
            }
        }
        // Agregar menú de cantidad de elementos a mostrar
        items.push({
            key: this.state.Request.Length.toString(),
            iconProps: { iconName: 'NumberedList' },
            name: this.state.Request.Length.toString(),
            subMenuProps: {
                items: [
                    {
                        key: '10',
                        name: '10',
                        onClick: () => this._changePaginationLength(10)
                    },
                    {
                        key: '15',
                        name: '15',
                        onClick: () => this._changePaginationLength(15)
                    },
                    {
                        key: '20',
                        name: '20',
                        onClick: () => this._changePaginationLength(20)
                    },
                    {
                        key: '30',
                        name: '30',
                        onClick: () => this._changePaginationLength(30)
                    },
                    {
                        key: '50',
                        name: '50',
                        onClick: () => this._changePaginationLength(50)
                    }
                ]
            }
        });
        // items.push({
        //   key: 'dt.settings',
        //   iconProps: { iconName: 'Settings' },
        //   name: '',
        // });
        return items;
    }
    _changePaginationLength(length) {
        this.setState({
            Request: Object.assign(Object.assign({}, this.state.Request), { Length: length, Start: 1 }),
        }, () => {
            if (typeof this.props.onRefreshDataTable === 'function') {
                this.props.onRefreshDataTable(this.state.Request);
            }
            else {
                this._refreshTable();
            }
            this.setState({
                commandBarFarItems: this._buildCommandBarFarItems()
            });
        });
    }
    _pivotItemClick(item) {
        if (this.props.onChangePivotItem) {
            this.props.onChangePivotItem(item.props.headerText);
        }
    }
    search(value) {
        this.setState({
            Request: Object.assign(Object.assign({}, this.state.Request), { Start: 1, Search: value })
        }, () => this._refreshTable());
    }
}
